// extracted by mini-css-extract-plugin
export default {"semi-button":"PositionSelector_semi-button__nWPj9","subtitle":"PositionSelector_subtitle__Tx922"};